<template>
    <el-card shadow="never">
        <div class="header">
          <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
            <el-breadcrumb-item>账号列表</el-breadcrumb-item>
          </el-breadcrumb>
          <el-button type="primary" class="editbtn" @click="add">新增</el-button>
        </div>
    </el-card>
    <el-card shadow="never" style="margin-top:20px">
        <el-table row-key="id" v-loading="baseData.loading" border :data="tableData.data" style="width: 100%;margin-top: 10px;">
          <el-table-column prop="id" label="ID" width="60"/>
          <el-table-column prop="username" label="账号"/>
          <el-table-column prop="realname" label="姓名"/>
          <el-table-column prop="ip" label="登录IP" />
          <el-table-column prop="loginTime" label="登录时间" />
          <el-table-column label="状态" >
            <template #default="scope">
                <p v-if="scope.row.status == 1">正常</p>
                <p v-else>冻结</p>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="220" >
            <template #default="scope">
              <el-button size="small" @click="edit(scope.row)" type="primary">编辑</el-button>
              <el-button size="small" @click="del(scope.row.id)" type="danger">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagestyle">
          <el-pagination
            v-model:current-page="searchForm.page"
            v-model:page-size="searchForm.limit"
            layout="sizes, prev, pager, next"
            :total="tableData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-card>
      <el-dialog v-model="baseData.userbox" :title="baseData.title">
        <el-form :model="form" label-width="120">
          <el-form-item label="账号">
            <el-input v-model="form.username" autocomplete="off" maxlength="150" show-word-limit/>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="form.realname" autocomplete="off" maxlength="150" show-word-limit/>
          </el-form-item>
          <el-form-item label="密码">
            <el-input
              v-model="form.password"
              placeholder="没密码或不需要更改密码，则无需填写"
              type="password"
              show-password
            />
          </el-form-item>
          <el-form-item label="重复密码">
            <el-input
              v-model="form.repassword"
              placeholder="没密码或不需要更改密码，则无需填写"
              type="password"
              show-password
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-radio-group v-model="form.status">
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="0">冻结</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="baseData.userbox = false">取消</el-button>
            <el-button type="primary" @click="save">
              提交
            </el-button>
          </span>
        </template>
      </el-dialog>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  const searchForm = reactive({
    limit:10,
    page:1,
  })
  const form = reactive({
    id:'',
    username: '',
    realname: '',
    repassword: '',
    password:'',
    status:1,
  })
  const baseData = reactive({
    loading:false,
    title:'',
    userbox:false,
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const getList = () => {
    baseData.loading = true
    api.userApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        tableData.data = res.data.data
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const add = (data:any) => {
    baseData.userbox = true
    baseData.title = '创建账号'
    form.id = ''
    form.username = ''
    form.realname = ''
    form.password = ''
    form.repassword = ''
    form.status = 1
  }
  const edit = (data:any) => {
    baseData.userbox = true
    baseData.title = '编辑账号'
    form.id = data.id
    form.username = data.username
    form.realname = data.realname
    form.password = ''
    form.repassword = ''
    form.status = data.status
  }
  const del = (id:number) => {
    baseData.loading = true
    api.userApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const save = () => {
    const loadingInstance = ElLoading.service({ fullscreen: true })
    api.userApi.save(form).then((res:any)=>{
      loadingInstance.close()
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        baseData.userbox = false
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  onMounted(() => {
    getList()
  })
  </script>